import { defineMessages } from "react-intl";

export const globalTranslations = defineMessages({
  share: { id: "generics-share", defaultMessage: "Partager" },
  login: { id: "generics-login", defaultMessage: "Se connecter" },
  logout: { id: "generics-logout", defaultMessage: "Se déconnecter" },
  signup: { id: "generics-signup", defaultMessage: "S'inscrire" },
  continue: { id: "generics-continue", defaultMessage: "Continuer" },
  cancel: { id: "generics-cancel", defaultMessage: "Annuler" },
  profile: { id: "generics-profile", defaultMessage: "Mon profil" },
  send: { id: "generics-send", defaultMessage: "Envoyer" },
  save: { id: "generics-save", defaultMessage: "Sauvegarder" },
  search: { id: "generics-search", defaultMessage: "Rechercher" },
  new: { id: "generics-novelty", defaultMessage: "Nouveauté" },
  recommended: { id: "generics-recommended", defaultMessage: "Coup de coeur" },
  sold: { id: "generics-sold", defaultMessage: "Vendu" },
  back: { id: "generics-back", defaultMessage: "Retour" },
  close: { id: "generics-close", defaultMessage: "Fermer" }
});

export const bookingTranslations = defineMessages({
  checkIn: { id: "generics-check-in-label", defaultMessage: "Arrivée" },
  checkOut: { id: "generics-check-out-label",  defaultMessage: "Départ" },
  period: {id: "generics-period", defaultMessage: "Période"},
  sellableToForeigners: {id: "sellable-to-foreigners", defaultMessage: "Vente aux étrangers"},
  secondaryResidence: {id: "secondary-residence", defaultMessage: "Résidence secondaire"},
  periodPlaceholder: { id: "generics-check-in-out-placeholder", defaultMessage: "Ajouter des dates" },
  availableFromDateShort: { id: "available-from-day-short", defaultMessage: "Dès le {date}" },
  availableFromDateLong: { id: "available-from-day-long", defaultMessage: "Disponible dès le {date}" },
  price: { id: "generics-price", defaultMessage: "Prix" },
  pricePerMonth: { id: "generics-price-per-month", defaultMessage: "{price} par mois" },
  nightsPeriod: { id: "generics-selection-period", defaultMessage: "{nightsCount, plural, =1 {# nuit} other {# nuits}}" },
  total: { id: "generics-total", defaultMessage: "Total" },
  priceOnDemand: { id: "generics-price-on-demand", defaultMessage: "Sur demande" },
  fullPriceOnDemand: { id: "generics-full-price-on-demand", defaultMessage: "Prix sur demande" },
  onDemandOnly: { id: "generics-on-demand-only", defaultMessage: "Sur demande uniquement" },
  onDemandHelper: { id: "generics-on-demand-textual", defaultMessage: "Disponible sur demande uniquement. Faites suite en contactant l'agence directement." },
  discount: { id: "generics-discount-valued", defaultMessage: "Réduction de {val}" },
  discountPeriod: { id: "generics-discount-period", defaultMessage: "À partir du {start} au {end}" },
  book: { id: "generics-booking-button", defaultMessage: "Réserver maintenant" },
  availabilities: { id: "generics-availabilities-button", defaultMessage: "Voir les disponibilités" },
  benefits: { id: "generics-benefits", defaultMessage: "Prestations" },
  customerCharge: { id: "generics-customer-charge", defaultMessage: "Frais de service" },
  customerChargeTooltip: { id: "generics-customer-charge-explanation", defaultMessage: "Ces frais sont liés aux coûts d'encaissement en ligne via le prestataire de paiement Stripe." },
  customerChargeAdaptive: { id: "generics-customer-charge-adaptive", defaultMessage: "Le montant dépendra du modèle de paiement que vous choisirez." },
  customerChargePrice: { id: "generics-customer-charge-price", defaultMessage: "{adaptive, select, true {jusqu'à } other {}}{amount}" }
});

export const cartTranslations = defineMessages({
  backHome: { id: "cart-process-end-back-button", defaultMessage: "Retour à la page d'accueil" },
  backCart: { id: "cart-process-back-cart-button", defaultMessage: "Modifier votre réservation" },
  nextPayment: { id: "cart-process-next-payment-button", defaultMessage: "Définir le modèle de paiement" },
  backInfo: { id: "cart-process-back-information-button", defaultMessage: "Modifier vos informations" },
  nextPay: { id: "cart-process-next-pay-button", defaultMessage: "Payer et finaliser la réservation" },
  paymentModel: { id: "cart-process-payment-model-title", defaultMessage: "Modèle de paiement" },
  booking: { id: "chart-item-resume-title", defaultMessage: "Réservation" },
  instantPay: { id: "chart-item-payment-title", defaultMessage: "Paiement immédiat" },
  amount: { id: "cart-item-price-amount", defaultMessage: "Montant" },
  down: { id: "cart-item-price-down", defaultMessage: "Acompte" },
  total: { id: "cart-item-price-total", defaultMessage: "Total" }
});

export const featureTranslations = defineMessages({
  livingSpace: { id: "generics-features-linvingspace", defaultMessage: "Surface habitable" },
  orientation: { id: "generics-features-orientation", defaultMessage: "Orientation" },
  isSellableToForeigners: { id: "generics-features-sellable-to-foreigners", defaultMessage: "Vente aux étrangers" },
  canBeSecondaryHome: { id: "generics-features-can-be-secondary-home", defaultMessage: "Résidence secondaire" },
  constructionYear: { id: "generics-features-construction-year", defaultMessage: "Année de construction" },
  floor: { id: "generics-features-floor", defaultMessage: "Étage" },
  isNew: { id: "generics-features-is-new", defaultMessage: "Neuf" },
  isFurnished: { id: "generics-features-is-furnished", defaultMessage: "Meublé" },
  rooms: { id: "generics-features-rooms", defaultMessage: "{roomCount, plural, =1 {Pièce: #} other {Pièces: #}}" },
  bedrooms: { id: "generics-features-bedrooms", defaultMessage: "{bedCount, plural, =1 {Chambre à coucher: #} other {Chambres à coucher: #}}" },
  bathrooms: { id: "generics-features-bathrooms", defaultMessage: "{bathCount, plural, =1 {Salle de bain: #} other {Salles de bain: #}}" },
  charges: { id: "generics-features-charges", defaultMessage: "Charges" },
  renovationFund: { id: "generics-features-renovation-fund", defaultMessage: "Fond de rénovation" },
  wifi: { id: "generics-features-wifi", defaultMessage: "WIFI" },
  tv: { id: "generics-features-tv", defaultMessage: "TV" },
  washingMachine: { id: "generics-features-washing-machine", defaultMessage: "Lave-linge" },
  laundryRoom: { id: "generics-features-laundry-room", defaultMessage: "Buanderie" },
  dishwasher: { id: "generics-features-dishwasher", defaultMessage: "Lave-vaisselle" },
  fireplace: { id: "generics-features-fireplace", defaultMessage: "Cheminée" },
  parking: { id: "generics-features-parking", defaultMessage: "Parking" },
  balcony: { id: "generics-features-balcony", defaultMessage: "Balcon" },
  terrace: { id: "generics-features-terrace", defaultMessage: "Terrasse" },
  pool: { id: "generics-features-pool", defaultMessage: "Piscine" },
  sauna: { id: "generics-features-sauna", defaultMessage: "Sauna" },
  hottub: { id: "generics-features-hottub", defaultMessage: "Jacuzzi" },
  hammam: { id: "generics-features-hammam", defaultMessage: "Hammam" },
  smoker: { id: "generics-features-no-smoking", defaultMessage: "Non-fumeur" },
  pet: { id: "generics-features-pet-compliant", defaultMessage: "Animaux admis" },
  disabledPerson: { id: "generics-features-disabled-compliant", defaultMessage: "Accès pour personnes handicapées" },
  smokerAlarm: { id: "generics-features-smoke-alarm", defaultMessage: "Détecteur de fumée" },
  carbonAlarm: { id: "generics-features-carbon-alarm", defaultMessage: "Détecteur de monoxyde de carbone" }
});

export const agencyTranslations = defineMessages({
  contactLabel: { id: "generics-contact", defaultMessage: "Contact" },
  contact: { id: "generics-agency-contact", defaultMessage: "Contacter l'agence" },
  about: { id: "generics-agency-about", defaultMessage: "À propos" }
});

export const formTranslations = defineMessages({
  greetingPlaceholder: { id: "generics-greeting-placeholder", defaultMessage: "Titre" },
  greetingMr: { id: "generics-greeting-opt-mr", defaultMessage: "M." },
  greetingMs: { id: "generics-greeting-opt-ms", defaultMessage: "Mme" },
  firstNamePlaceholder: { id: "generics-first-name-placeholder", defaultMessage: "Prénom" },
  lastNamePlaceholder: { id: "generics-last-name-placeholder", defaultMessage: "Nom" },
  emailPlaceholder: { id: "generics-email-placeholder", defaultMessage: "E-mail" },
  phonePlaceholder: { id: "generics-phone-placeholder", defaultMessage: "Téléphone" },
  mobilePlaceholder: { id: "generics-mobile-placeholder", defaultMessage: "Mobile" },
  streetPlaceholder: { id: "generics-street-placeholder", defaultMessage: "Rue" },
  streetNumberPlaceholder: { id: "generics-street-number-placeholder", defaultMessage: "N°" },
  streetComplementPlaceholder: { id: "generics-street-complement-placeholder", defaultMessage: "Adresse complémentaire" },
  zipPlaceholder: { id: "generics-zip-placeholder", defaultMessage: "NPA" },
  cityPlaceholder: { id: "generics-city-placeholder", defaultMessage: "Localité" },
  countryPlaceholder: { id: "genrics-country-placeholder", defaultMessage: "Sélectionnez un pays" },
  messagePlaceholder: { id: "generics-message-placeholder", defaultMessage: "Dites-nous comment nous pouvons vous aider." },
  emptyError: { id: "generics-form-empty-error", defaultMessage: "Cette information est requise." },
  mailError: { id: "generics-form-mail-error", defaultMessage: "Cet e-mail n'est pas valide." },
  phoneError: { id: "generics-form-phone-error", defaultMessage: "Ce numéro n'est pas valide. Veuillez respecter le format international (exemple: +41 xx xxx xx xx)." },
  sendWithBookingPeriod: { id: "generics-form-bookingperiod-label", defaultMessage: "Souhaitez-vous transmettre la période de réservation sélectionnée ?" },
  minError: { id: "generics-form-min-error", defaultMessage: "Doit contenir au moins {value, plural, =1 {# caractère} other {# caractères}}." },
  optionError: { id: "generics-form-option-error", defaultMessage: "Veuillez sélectionner cette option." },
  sent: { id: "generics-form-send-success", defaultMessage: "Votre message a été envoyé avec succès." },
  saved: { id: "generics-form-save-success", defaultMessage: "Vos données ont été sauvegardées." },
  failed: { id: "generics-form-send-error", defaultMessage: "Une erreur est survenue à l'envoi de votre message." },
  failedSave: { id: "generics-form-save-error", defaultMessage: "Une erreur est survenue à la sauvegarde." }
})
